import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconZip"><Path d="M10.5 16V14.5H13.5V16C13.5 16.8284 12.8284 17.5 12 17.5C11.1716 17.5 10.5 16.8284 10.5 16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 3V21H3L3.00006 3.00001L21 3ZM9 5V6.5H15V5H9ZM9 9H15V10.5H9V9ZM9 13V16C9 17.6569 10.3431 19 12 19C13.6569 19 15 17.6569 15 16V13H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconZip;
